<div class="background-cover"></div>
<div class="profile-container payment-container add-new-cc-modal">
  <div class="column-0">
    <div class="settings-section selections">
      <label class="section-label">{{
        'labels.addingNewCreditCardDetails' | translate
      }}</label>

      <div class="profile-form">
        <ops-input
          [label]="'labels.shortName' | translate"
          formName="creditCard.shortName"
          [value]="creditCard.shortName"
          (changed)="onValueChange($event, 'shortName')"
          (validationError)="onErrorHandler($event, 'shortName')"
          mandatory="true"
          type="text"
        ></ops-input>

        <ops-input
          [label]="'labels.description' | translate"
          formName="creditCard.description"
          [value]="creditCard.description"
          (changed)="onValueChange($event, 'description')"
          (validationError)="onErrorHandler($event, 'description')"
          mandatory="true"
          type="text"
        ></ops-input>

        <ops-select
          [options]="bankAccounts"
          showSearch="true"
          [defaultSelected]="creditCardBank"
          [formName]="creditCardBank"
          [label]="'labels.connectedBankAccount' | translate"
          mandatory="true"
          (changed)="onSelectChangeForCC($event, 'bankAccount')"
        ></ops-select>

        <ops-select
          [options]="cutOffDays"
          [defaultSelected]="creditCard.cutOffDateDay"
          [formName]="creditCard.cutOffDateDay"
          [label]="'labels.cutOffDate' | translate"
          mandatory="true"
          (changed)="onSelectChangeForCCOpt($event, 'cutOffDateDay')"
        ></ops-select>

        <ops-select
          [options]="cutOffDays"
          showSearch="true"
          [defaultSelected]="creditCard.settlementDateDay"
          formName="creditCard.settlementDateDay"
          [label]="'labels.settlementDate' | translate"
          mandatory="true"
          (changed)="onSelectChangeForCCOpt($event, 'settlementDateDay')"
        ></ops-select>

        <ops-input-preview
          [label]="'labels.billingPeriod' | translate"
          [textOnly]="true"
          [value]="creditCardBillingPeriod"
          type="text"
        ></ops-input-preview>

        <ops-select
          rotateDropdownDirection="'true'"
          [options]="mainCurrencies"
          mandatory="true"
          [defaultSelected]="creditCard.currencyCode"
          [formName]="creditCard.currencyCode"
          [label]="'labels.currencyCode' | translate"
          mandatory="true"
          (changed)="onValueChange($event, 'currencyCode')"
        ></ops-select>
        <ops-checkbox
          [label]="'labels.isFavorite' | translate"
          [formName]="creditCard.isFavorite"
          [value]="creditCard.isFavorite"
          (changed)="onValueChange($event, 'isFavorite')"
        ></ops-checkbox>

        <div class="nfut-container">
          <ops-calendar
            invertDirection="true"
            [label]="'labels.validUntil' | translate"
            (dateChanged)="onValueChange($event, 'expirationDate')"
            formName="creditCard.expirationDate"
            [minDate]="minExpirationDate"
            [maxDate]="maxExpirationDate"
            [date]="creditCard.expirationDate"
          ></ops-calendar>

          <ops-input
            placeholder="1234"
            [label]="'labels.lastFourDigits' | translate"
            (validationError)="onErrorHandler($event, 'lastFourDigits')"
            formName="creditCard.lastFourDigits"
            [value]="creditCard.lastFourDigits"
            mandatory="true"
            (changed)="onValueChange($event, 'lastFourDigits')"
            type="last4digits"
          ></ops-input>
        </div>
      </div>

      <div class="create-actions">
        <button class="cancel-button" (click)="closeModalHandle()">
          {{ 'labels.cancel' | translate }}
        </button>
        <button
          class="save-button"
          [class.disabled]="!isValid"
          [disabled]="!isValid"
          (click)="saveNewCreditCard()"
        >
          {{ 'labels.save' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Bank Accounts Missing Modal -->
<div *ngIf="showBankAccountsModal" class="modal-overlay">
  <div class="modal-content">
    <div class="modal-header">
      <h3>{{ 'labels.bankAccountsMissing' | translate }}</h3>
    </div>
    <div class="modal-body">
      <p>{{ 'messages.bankAccountsRequired' | translate }}</p>
    </div>
    <div class="modal-footer">
      <button class="modal-button primary" (click)="closeBankAccountsModal()">
        {{ 'labels.ok' | translate }}
      </button>
    </div>
  </div>
</div>
